import { Box, SimpleGrid, Image, Button, IconButton, Spacer } from "@chakra-ui/react"
import { personalitaData } from "../data/personalita"
import { ArrowForwardIcon, ArrowBackIcon, ExternalLinkIcon } from "@chakra-ui/icons"
import ReactCardFlip from 'react-card-flip';
import { useState } from "react";


const PersonalitaComp = () => {
  const [personalita, setPersonalita] = useState(personalitaData);

  const handleFlipCard = (e, id) => {
    e.preventDefault();

    const arrayCopy = personalita.map(data =>
      data.id === id ? { id: data.id, nomeCognome: data.nomeCognome, description: data.description, img: data.img, isFlipped: !data.isFlipped } : data
    )

    setPersonalita(arrayCopy);
  }

  const handleFlippedCard = (e, id) => {
    e.preventDefault();
    const arrayCopy = personalita.map(data =>
      data.id === id ? { id: data.id, nomeCognome: data.nomeCognome, description: data.description, img: data.img, isFlipped: !data.isFlipped } : data
    )

    setPersonalita(arrayCopy);
  }

  const redirectToTresoldiSite = () => {
    window.open('http://www.i-v-a-n.net/', '_blank')
  }

  return (
    <SimpleGrid columns={[1, null, 2, 3]} spacing='40px' textColor='white' >

      {
        personalita.map((data) => {
          return (
            <ReactCardFlip key={data.id} isFlipped={data.isFlipped} flipDirection='horizontal'>
              <Box maxW='sm' borderRadius='lg' overflow='hidden' shadow='lg' bgGradient="linear(to-r, green.600, green.400)">
                <Box position='relative'>
                  <Box background='green.500' overflow='hidden'>
                    <Image
                      src={data.img}
                      alt='No image'
                      height='400px'
                      width='full'
                      objectFit='cover'
                      opacity='0.3'
                    />
                  </Box>

                  <Box
                    mt='1'
                    fontWeight='semibold'
                    as='h4'
                    lineHeight='tight'
                    position='absolute'
                    bottom='0'
                    p={2}
                    display='flex'
                    alignItems='center'
                    w='full'
                  >
                    {data.nomeCognome}
                    <Spacer />

                    {data.nomeCognome === 'IVAN TRESOLDI' ? <IconButton icon={<ExternalLinkIcon />} variant='link'
                      textColor='white'
                      onClick={redirectToTresoldiSite}
                    >
                      Vai al sito
                    </IconButton> : null}
                  </Box>

                </Box>

                <Box p='6'>
                  <Box
                    mt='1'
                    fontWeight='normal'
                    as='h4'
                    lineHeight='tight'
                    textAlign='justify'
                    noOfLines={8}

                  >
                    {data.description}
                  </Box>
                </Box>
                <Box display='flex' justifyContent='center' mb={5}>
                  <Button rightIcon={<ArrowForwardIcon />} variant='link' textColor='white' onClick={(e) => handleFlipCard(e, data.id)}>
                    Continua a leggere
                  </Button>

                </Box>
              </Box>

              {/* Lato B */}

              <Box maxW='sm' borderRadius='lg' overflow='hidden' shadow='lg' bgGradient="linear(to-r, green.600, green.400)">
                <Box p='6'>
                  <Box
                    mt='1'
                    fontWeight='normal'
                    as='h4'
                    lineHeight='tight'
                    textAlign='justify'

                  >
                    {data.description}
                  </Box>
                </Box>
                <Button leftIcon={<ArrowBackIcon />} variant='link' w='full' textColor='white' mb={5} onClick={(e) => handleFlippedCard(e, data.id)}>
                  Indietro
                </Button>
              </Box>
            </ReactCardFlip>
          )
        })
      }


    </SimpleGrid>
  )
}

export default PersonalitaComp